/**
 * Class for Supported Application Stage
 */
export class Stage {
  public static INITIAL_REVIEW = 'INITIAL_REVIEW';
  public static READY_FOR_REVIEW = 'READY_FOR_REVIEW';
  public static WAITING_FOR_EVIDENCE = 'WAITING_FOR_EVIDENCE';
  public static READY_FOR_DECISION = 'READY_FOR_DECISION';
  public static FINAL_TASKS = 'FINAL_TASKS';
  public static COMPLETED = 'COMPLETED';
  public static POST_ISSUE_AUDIT = 'POST_ISSUE_AUDIT';
  public static AUDIT = 'AUDIT';
  public static AUDIT_COMPLETED = 'AUDIT_COMPLETED';
}

export const DefaultSelectedStages = [
  Stage.INITIAL_REVIEW,
  Stage.READY_FOR_REVIEW,
  Stage.READY_FOR_DECISION,
  Stage.WAITING_FOR_EVIDENCE,
];

export const STAGE_V2 = {
  COMPLETED: 'COMPLETED',
  FINAL_TASKS: 'FINAL_TASKS',
  INITIAL_REVIEW: 'INITIAL_REVIEW',
  READY_FOR_DECISION: 'READY_FOR_DECISION',
  READY_FOR_REVIEW: 'READY_FOR_REVIEW',
  WAITING_FOR_EVIDENCE: 'WAITING_FOR_EVIDENCE',
  POST_ISSUE_AUDIT: 'POST_ISSUE_AUDIT',
  AUDIT: 'AUDIT',
  AUDIT_COMPLETED: 'AUDIT_COMPLETED',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  INELIGIBLE: 'INELIGIBLE',
  WITHDRAWN: 'WITHDRAWN',
  WAIVED: 'WAIVED',
  RESCINDED: 'RESCINDED',
  EVIDENCE_ON_HOLD: 'EVIDENCE_ON_HOLD',
  PIA_SKIPPED: 'PIA_SKIPPED',
  PEER_REVIEW: 'PEER_REVIEW',
  FRAUD_INVESTIGATION: 'FRAUD_INVESTIGATION',
  CARRIER_REVIEW: 'CARRIER_REVIEW',
  REINSTATEMENT_REVIEW: 'REINSTATEMENT_REVIEW',
  WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
  LEGAL_REVIEW: 'LEGAL_REVIEW',
  POLICY_CLOSED: 'POLICY_CLOSED',
  EVIDENCE_REVIEW: 'EVIDENCE_REVIEW',
  RESOLVED: 'RESOLVED',
};
